import { useCallback, useRef } from 'react';
import useOnboardingTour from './useOnboardingTour';

const useOnboardingTarget = (id) => {
  const { registerTarget } = useOnboardingTour();
  const ref = useRef(null);

  const setRef = useCallback(
    (node) => {
      ref.current = node;
      registerTarget(id, node);
    },
    [id, registerTarget]
  );

  return setRef;
};

export default useOnboardingTarget;
